module.exports = __webpack_public_path__ + "images/f97c5e4c.dld_qrcode.png";


//////////////////
// WEBPACK FOOTER
// ./images/dld_qrcode.png
// module id = 264
// module chunks = 0